<template>
    <vx-card no-shadow>
        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-4">
            <vs-input type="password" v-validate="{required : true, min:8}" name="SENHA ANTIGA" class="w-full" icon-pack="feather" icon="icon-unlock" icon-no-border label="SENHA ANTIGA" v-model="oldPassword"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('SENHA ANTIGA')">{{ errors.first('SENHA ANTIGA') }}</span>
        </div>

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-4">
            <vs-input type="password" v-validate="{required : true, min: 8}" name="NOVA SENHA" ref="NOVA SENHA" class="w-full" icon-pack="feather" icon="icon-unlock" icon-no-border label="NOVA SENHA" v-model="newPassword"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('NOVA SENHA')">{{ errors.first('NOVA SENHA') }}</span>
        </div>

        <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-4">
            <vs-input type="password" v-validate="'required|confirmed:NOVA SENHA'" name="CONFIRME A SENHA" class="w-full" icon-pack="feather" icon="icon-unlock" icon-no-border label="CONFIRME A SENHA" v-model="confirmPassword"></vs-input>
            <span class="text-danger text-sm" v-show="errors.has('CONFIRME A SENHA')">{{ errors.first('CONFIRME A SENHA') }}</span>
        </div>

        <div class="flex flex-wrap items-center">
            <vs-button class="mt-2" @click="save">Salvar Alterações</vs-button>
        </div>
    </vx-card>
</template>

<script>
import firebase from '@/firebase/firebase'
import {mask} from 'vue-the-mask'

export default {
    directives : {mask},

    data () {
        return {
            oldPassword : '',
            newPassword : '',
            confirmPassword : ''
        }
    },

    mounted () {
        // this.$message.config({ top: '80px'})
    },

    methods : {

        async save () {
            let activeUserInfo = this.$store.getters.getUserStoredData
            
            try {
                this.$vs.loading()
                let validationIsOk = await this.$validator.validateAll()
                if(!validationIsOk) return

                await firebase.auth().signInWithEmailAndPassword(activeUserInfo.email, this.oldPassword)
                await firebase.auth().currentUser.updatePassword(this.newPassword)
                this.$message.success('Senha alterada com sucesso! :)', 8)
            } catch(err) {
                let msg = 'Erro desconhecido' 
                switch(err.code) {
                    case 'auth/wrong-password':
                        this.msg = 'Senha incorreta!'
                        break;
                    case 'auth/too-many-requests':
                        this.msg = 'Muitas tentativas de alteração da senha realizadas. Se você persistir, será bloqueado permanentemente.'
                        break;
                }

                this.$vs.dialog({
                    type: 'alert',
                    title: 'Erro ao alterar senha',
                    text: this.msg,
                    acceptText: 'Fechar'
                })
            } finally {
                await this.clearFields()
                this.$vs.loading.close()
            }
        },

        clearFields () {
            this.oldPassword     = '';
            this.newPassword     = '';
            this.confirmPassword = '';
        }
    }
}
</script>